<template>
    <div class="nav-root mb-2 px-2">
        <div class="nav-layout d-flex">
            <NavLink
                class="nav-item"
                :to="cockpitRoute()"
                :label="$t('shared.userNavSection.myPage')"
                exact
            />
            <NavLink
                class="nav-item"
                :to="favoritesRoute()"
                :label="$t('shared.userNavSection.myFavorites')"
            />
            <NavLink
                class="nav-item"
                :to="spotlightRoute()"
                :label="$t('shared.userNavSection.myProfile')"
            />
            <NavLink
                class="nav-item"
                :to="testsRoute()"
                :label="$t('shared.userNavSection.myTests')"
            />
            <NavLink
                v-if="hasResources"
                class="nav-item"
                :to="internalResourcesRoute()"
                :label="$t('shared.userNavSection.internalResources')"
            />
            <NavLink
                v-if="hasCalendar"
                class="nav-item"
                :to="calendarRoute()"
                :label="$t('shared.userNavSection.calendar')"
            />
        </div>
    </div>
</template>

<script>
import NavLink from '~/components/navigation/NavLink';
import ResourceService from '~/services/ResourceService';
import UniversityService from '~/services/UniversityService';

export default {
    name: 'UserNavSection',
    components: { NavLink },
    data: function() {
        return {
            hasResources: false,
            hasCalendar: false,
        };
    },
    mounted() {
        ResourceService.hasResources().then(result => {
            this.hasResources = result;
        });
        UniversityService.hasCalendar().then(doesIt => {
            this.hasCalendar = doesIt;
        });
    },
    methods: {
        cockpitRoute: function() {
            return this.$URLS.mypage;
        },
        favoritesRoute: function() {
            return this.$URLS.favorites;
        },
        spotlightRoute: function() {
            return this.$URLS.spotlight;
        },
        testsRoute: function() {
            return this.$URLS.tests;
        },
        internalResourcesRoute: function() {
            return this.$URLS.internalResources;
        },
        calendarRoute: function() {
            return this.$URLS.calendar.concat(this.$URLS.book);
        },
        isProd() {
            return IS_PROD;
        },
    },
};
</script>

<style scoped>
.nav-root {
    max-width: var(--grid-width);
    height: 26px;
    margin: auto;
}
.nav-item {
    color: rgba(255, 255, 255, 0.9);
    margin-right: 42px;
    height: 100%;
    padding: 0;
    z-index: 2;
}
.nav-layout {
    height: 100%;
}
.activeClass {
    border-bottom: 2px solid white;
    color: white;
}

@media only screen and (max-width: 600px) {
    .nav-root {
        max-width: 100vw;
    }

    .nav-item:last-child {
        margin-right: 0;
    }

    .nav-item.disabled {
        flex-shrink: 100;
    }

    .nav-item {
        margin-right: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        flex-basis: auto;
        width: fit-content;
    }

    .activeClass {
        max-width: min-content;
        flex-shrink: 0;
    }
}
</style>
